var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createStyleSheet, useStyleSheet, Icon, Text, View } from '@gopeerproject/ui-kit';
import { ChartFrame } from '../ChartFrame';
export const LevelChart = (_a) => {
    var { data = 0, color = '#0079FD', scale } = _a, baseChartProps = __rest(_a, ["data", "color", "scale"]);
    const styles = useStyleSheet(getStyles);
    const description = React.useMemo(() => `${data.toFixed(2)}`, [data]);
    let fillPercent = (data / scale.max) * 100;
    fillPercent = fillPercent < 0 ? 0 : fillPercent > 100 ? 100 : fillPercent;
    const axis = React.useMemo(() => {
        const arr = [];
        for (let i = scale.min; i <= scale.max; i += scale.interval)
            arr.push(i);
        return arr;
    }, [scale]);
    return (React.createElement(ChartFrame, Object.assign({ description: description }, baseChartProps),
        React.createElement(View, { style: styles.backgroundBar },
            React.createElement(View, { style: styles.arrowContainer },
                React.createElement(View, { style: [styles.arrowInner, { left: `${fillPercent}%` }] },
                    React.createElement(Icon, { name: 'play', filled: true, size: 19 }))),
            React.createElement(View, { style: [
                    styles.fillBar,
                    { width: `${fillPercent}%`, backgroundColor: color }
                ] })),
        React.createElement(View, { style: styles.legend }, axis.map((val) => (React.createElement(Text, { key: `legend-${val}`, style: styles.legendLabel, type: 'body', size: 'sm', weight: 'regular' }, val))))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    backgroundBar: {
        backgroundColor: color.black.p10,
        width: '100%',
        height: size.C,
        marginTop: size.M,
        borderRadius: size.G
    },
    fillBar: {
        height: '100%',
        position: 'absolute',
        borderRadius: size.B,
        transitionProperty: ['width'],
        transitionDuration: ['.25s']
    },
    arrowContainer: {
        bottom: '100%',
        marginTop: -19
    },
    arrowInner: {
        width: size.F,
        marginLeft: -10,
        rotate: '90deg'
    },
    legend: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: size.C
    },
    legendLabel: {
        color: color.invert2.p56
    }
}));
//# sourceMappingURL=index.js.map